const dialogFieldDescriptions = {
  salesCustomer: {
    customerLevelName: '用于客户等级展示和筛选，请输入便于业务人员识别的等级名称。',
    rechargeTypeName: '用于区分不同充值来源或活动类型，保存后可在充值弹窗中选择。',
    rechargeType: '请选择本次充值对应的业务类型，后续充值记录会按该类型留痕。',
    changeWay: '系统默认当前变动方式，不需要手动调整。',
    balance: '当前客户账户可用余额，仅用于充值前核对。',
    rechargeAmount: '请输入本次实际充值金额，系统会同步生成金额大写用于核对。',
    rechargeRemark: '请填写本次充值原因或凭证说明，便于财务后续追溯。',
    freightBalance: '当前客户运费账户余额，仅用于红冲前核对。',
    walletBalance: '当前客户钱包账户余额，仅用于红冲前核对。',
    redFlushAmount: '请输入需要红冲的金额，提交前请确认账户类型和余额是否匹配。',
    redFlushAccountType: '请选择本次红冲要扣减的钱包或运费账户，避免冲减错误账户。',
    redFlushRemark: '请填写本次红冲原因或凭证说明，便于财务后续核对。'
  }
}

export default dialogFieldDescriptions
